import {useState, useEffect} from 'react'
import arrowUpIcon from '@/assets/images/arrow-up.svg';

function BackToTopButton() {
    const [showScrollTop, setShowScrollTop] = useState(false);

  // Handle scroll event to show/hide button
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if(!showScrollTop) return null;

  return (
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className='scroll-to-top bottom-4 left-4 bg-gray-300 p-2 rounded-full fixed z-50'
      >
        <img src={arrowUpIcon} alt='Scroll to top' />
      </button>
  )
}

export default BackToTopButton